import React, { ReactNode, useContext } from "react";
import { observer } from "mobx-react";
import { EventOffer } from "@gp/offer";
import { OfferStoreContext } from "@gp/components";

import { EventTeamsInfoCore } from "@features/offer/shared/event/details";
import EventViewStore from "@state/stores/offer/event/EventViewStore.mobile";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";

export const EventTeamsInfo = observer(function EventTeamsInfo({
	event,
	children,
}: {
	event: EventOffer;
	children: ReactNode;
}) {
	const store = useContext(OfferStoreContext) as
		| EventViewStore
		| AdditionalOfferViewStore;

	return (
		<EventTeamsInfoCore store={store} event={event}>
			{children}
		</EventTeamsInfoCore>
	);
});
